import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import "./layout.css"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        logo: file(relativePath: { eq: "logo.svg" }) {
          id
          name
          publicURL
        }
        page: contentfulHomepage {
          title
          footerAddress {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <Header logo={data.logo} siteTitle={data.page.title} />
        <main>{children}</main>
        <Footer
          footerAddress={
            data.page.footerAddress
              ? data.page.footerAddress.childMarkdownRemark.html
              : null
          }
        />
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
